import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Api_Success_Res } from "./api.types";
import type { SessionDto, SessionStatusMap } from "dtos/session.dto";

export const sessionService = {
  useGetSessions: (userId: string | null) => {
    return useQuery({
      queryKey: ["sessions", userId],
      queryFn: async () => {
        const res = await api.get(`/sessions/${userId}`);
        return (res.data as T_Api_Success_Res<SessionDto[]>).result;
      },
      enabled: !!userId,
    });
  },

  useTerminate: () => {
    return useMutation({
      mutationKey: ["sessions/terminate"],
      mutationFn: async (params: { userId: string; sessionId: string }) => {
        const res = await api.delete(`/sessions/${params.userId}/${params.sessionId}`);
        return res.data as T_Api_Success_Res<{ sessionId: string }>;
      },
    });
  },

  useTerminateAll: () => {
    return useMutation({
      mutationKey: ["sessions/terminate-all"],
      mutationFn: async (userId: string) => {
        const res = await api.delete(`/sessions/${userId}`);
        return res.data as T_Api_Success_Res<{ terminated: number }>;
      },
    });
  },
  useBulkStatus: (userIds: string[]) => {
    return useQuery({
      queryKey: ["sessions/status", userIds],
      queryFn: async () => {
        const res = await api.post(`/sessions/status`, {
          user_ids: userIds,
        });
        return (res.data as T_Api_Success_Res<SessionStatusMap>).result;
      },
      enabled: userIds.length > 0,
      refetchInterval: 60_000,
    });
  },
};
